module.exports = __webpack_public_path__ + "static/media/key-ingredients.bf508a11.png";